import React, { useContext } from "react";
import { Card } from "reactstrap";

import CustomTooltip from "views/pages/manage/common/customTooltip/CustomTooltip";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";
import APopover from "../../../../common/a-popover";

import { EyeIcon } from "./EyeIcon";
import { ReceiptListContext } from "./context";

export const BUPopover = ({ businessArea, businessAreaOptions }) => {
  const { buDescriptionMap, setBuDescriptionMap } =
    useContext(ReceiptListContext);

  const [businessAreaDesc, setBusinessAreaDesc] = React.useState("");
  const [isFetching, setIsFetching] = React.useState(false);

  const getBuDesc = async () => {
    setIsFetching(true);
    const businessAreaId = businessAreaOptions.filter(
      (bu) => bu.value === businessArea
    )[0]?.businessAreaId;

    const resp = businessAreaId && await fetchAllPromisedData(
      `${endpoint?.businessArea.getBusinessAreaByIdV2}/${businessAreaId}`
    );

    if (resp) {
      const description = resp?.businessAreaDesc;
      setBusinessAreaDesc(description);
      setBuDescriptionMap((prev) => ({ ...prev, [businessArea]: description }));
    } else setBusinessAreaDesc("Unable to show data!");
    setIsFetching(false);
  };

  return (
    <APopover
      buttonComponent={(onClick, styles) => (
        <span
          onClick={(e) => {
            onClick(e);
            buDescriptionMap[businessArea]
              ? setBusinessAreaDesc(buDescriptionMap[businessArea])
              : getBuDesc();
          }}
          style={{ cursor: "pointer" }}
        >
          <EyeIcon />
        </span>
      )}
      menuComponent={(closeForm) => (
        <>
          <Card
            className="mb-0 regular-body label-color"
            style={{ borderRadius: "12px" }}
          >
            <div className="p-2 text-bold">
              {isFetching ? "Loading..." : businessAreaDesc}
            </div>
          </Card>
        </>
      )}
      transformOriginVertical="center"
      transformOriginHorizontal="left"
    />
  );
};

export const AppIdPopover = ({ rowData }) => {
  return (
    <CustomTooltip
      title={
        <div className="p-2 d-flex flex-column" style={{ maxWidth: "300px" }}>
          <div className="semi-bold d-flex mr-3 flex-shrink-0 align-items-center">
            <div className="text-bold">Course ID:&nbsp;</div>
            <div>{rowData?.courseId || "-"}</div>
          </div>
          <div className="semi-bold d-flex align-items-center">
            <div className="text-bold">Term:&nbsp;</div>
            <div>{rowData?.term || "-"}</div>
          </div>
        </div>
      }
      showOnClick={true}
      placement={"bottom-start"}
      maxWidth={"none"}
    >
      <span style={{ cursor: "pointer" }}>
        <EyeIcon />
      </span>
    </CustomTooltip>
  );
};
